import {Request} from './Request';

export class ClearCacheRequest implements Request {
    chargePointSelectList: string[];

    constructor(chargePointSelectList: string[]) {
        this.chargePointSelectList = chargePointSelectList;
    }

    public toString = (): string => {
        return `ClearCacheRequest (chargePointSelectList: ${this.chargePointSelectList})`;
    }
}

/*
* chargePointSelectList: JSON;EVB-P20261797;-
_chargePointSelectList: 1
keyType: PREDEFINED
confKey: BlinkRepeat
*
*
*chargePointSelectList: JSON;EVB-P20261797;-
_chargePointSelectList: 1
keyType: CUSTOM
customConfKey: customKey
value: customKeyValu
*
* */
